import { Card, CardContent, Typography, Stack } from '@mui/material';
import TransferList from '../../TransferList';

interface LabourItemDefinition {
  id: string;
  name: string;
}

interface LabourItemsAssignmentCardProps {
  availableItems: LabourItemDefinition[];
  assignedItems: LabourItemDefinition[];
  searchText: string;
  onSearchChange: (text: string) => void;
  onMoveToAssigned: (itemId: string) => void;
  onMoveToAvailable: (itemId: string) => void;
  loading?: boolean;
  optional?: boolean;
}

export function LabourItemsAssignmentCard({
  availableItems,
  assignedItems,
  searchText,
  onSearchChange,
  onMoveToAssigned,
  onMoveToAvailable,
  loading = false,
  optional = false,
}: LabourItemsAssignmentCardProps) {
  return (
    <Card variant="outlined" data-testid="labour-items-assignment-card">
      <CardContent>
        <Stack spacing={2}>
          {/* Card Title */}
          <Typography variant="h6" component="h3">
            {optional
              ? 'Assign Labour Items (Optional)'
              : 'Assign Labour Items'}
          </Typography>

          {/* Explanatory Text */}
          <Typography variant="body2" color="text.secondary">
            {optional
              ? 'Select which labour items belong to this group. You can add items now or edit the group later to assign items. Users assigned to this group will only see these items when booking labour.'
              : 'Select which labour items belong to this group. Users assigned to this group will only see these items when booking labour.'}
          </Typography>

          {/* Transfer List */}
          <TransferList
            availableItems={availableItems}
            assignedItems={assignedItems}
            searchText={searchText}
            onSearchChange={onSearchChange}
            onMoveToAssigned={onMoveToAssigned}
            onMoveToAvailable={onMoveToAvailable}
            loading={loading}
          />
        </Stack>
      </CardContent>
    </Card>
  );
}
